import axios from 'axios';

const state = () => ({
  loading: false,
  error: null,
  claimResult: null,
});

const getters = {
  hasClaimed: state => state.claimResult !== null,
  photoCount: state => state.claimResult?.photoCount ?? 0,
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  setClaimResult(state, result) {
    state.claimResult = result;
  },
  reset(state) {
    state.loading = false;
    state.error = null;
    state.claimResult = null;
  },
};

const actions = {
  async claimCode({ commit, rootState }, code) {
    commit('reset');
    commit('setLoading', true);
    const accessToken = rootState.user.token;

    try {
      const { data } = await axios.post(
        process.env.VUE_APP_API_URL + '/photo/photobooth/claim',
        { code },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      commit('setClaimResult', data);
    } catch (e) {
      const status = e.response?.status;
      if (status === 404) {
        commit('setError', 'Invalid code. Please check and try again.');
      } else if (status === 400) {
        commit('setError', 'This code has expired. Please get a new code.');
      } else {
        commit('setError', 'Something went wrong. Please try again.');
      }
    } finally {
      commit('setLoading', false);
    }
  },

  async claimFotoshare({ commit, rootState, dispatch }, url) {
    commit('reset');
    commit('setLoading', true);
    const accessToken = rootState.user.token;

    console.log('[FotoShare] Claiming URL:', url);
    console.log(
      '[FotoShare] API endpoint:',
      process.env.VUE_APP_API_URL + '/photo/fotoshare/claim',
    );

    try {
      const { data } = await axios.post(
        process.env.VUE_APP_API_URL + '/photo/fotoshare/claim',
        { url },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      console.log('[FotoShare] API success:', JSON.stringify(data));
      commit('setClaimResult', data);
      await dispatch('photos/fetchPhotos', null, { root: true });
    } catch (e) {
      const status = e.response?.status;
      const responseData = e.response?.data;
      console.log('[FotoShare] API error:', status, JSON.stringify(responseData));
      console.log('[FotoShare] Full error:', e.message);
      if (status === 404) {
        commit('setError', `No photos found. (${responseData?.message || 'unknown'})`);
      } else if (status === 400) {
        commit('setError', 'Invalid fotoshare link. Please try scanning again.');
      } else {
        commit('setError', `Something went wrong. (${status}: ${e.message})`);
      }
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
